/**
 * 公共的一些路由
 */
const routerCommon = [
  {
    path: '/common-view-video',
    name: 'CommonViewVideo',
    meta: {
      title: '视频查看',
      needLogin: true,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-common/CommonViewVideo.vue'),
  },
];

export default routerCommon;
